import { ColumnsType } from 'antd/es/table';
import Button from 'components/Button';
import ModalConfirm, { useModalConfirmRef } from 'components/Modal/ModalConfirm';
import NewTable from 'components/NewTable';
import settingServiceActions from 'features/settingService/services/actions';
import settingApis from 'features/settingService/services/apis';
import settingServiceSelectors from 'features/settingService/services/selectors';
import { IResSupplier } from 'features/settingService/services/types/supplier';
import { useAppDispatch } from 'store/hooks';
import styled from 'styled-components';
import { formatCurrency } from 'utils/formatCurrency';
import { formatPhone } from 'utils/formatPhone';
import toast from 'utils/toast';
import AddOrUpdateSupplierModal, { IModalAddOrUpdateSupplierRef } from './Modals/AddOrUpdateSupplierModal';
import { useRef } from 'react';

const SuppliersSettingTable = () => {
  const dispatch = useAppDispatch();
  const confirmModalRef = useModalConfirmRef();
  const addOrUpdateSupplierRef = useRef<IModalAddOrUpdateSupplierRef>(null);

  const supplierData = settingServiceSelectors.getSuppliersSettingListDataSelector();
  const loading = settingServiceSelectors.getSuppliersSettingListLoading();
  const params = settingServiceSelectors.getSuppliersSettingParamsSelector();
  const totalElement = supplierData.totalElements;
  const suppliers: IResSupplier[] = supplierData.content;

  const onDeleteSupplier = async (id: string) => {
    try {
      await settingApis.deleteSupplier(id);
      toast.success('Delete Supplier successfully');
      dispatch(settingServiceActions.setSuppliersSettingParams());
    } catch (error) {}
  };

  const handleDeleteSupplier = (supplier: IResSupplier) => {
    confirmModalRef.current?.open(`Do you want to remove ${supplier.name}?`, () => onDeleteSupplier(supplier.id));
  };
  const handleEditSupplier = (supplier: IResSupplier) => {
    addOrUpdateSupplierRef.current?.open(supplier, () => {
      dispatch(settingServiceActions.setSuppliersSettingParams());
    });
  };
  const handleDetailSupplier = (supplier: IResSupplier) => {
    // console.log('supplier', supplier);
    // navigate to report page
  };

  const columns: ColumnsType<IResSupplier> = [
    {
      title: 'Supplier',
      dataIndex: 'name',
      key: 'name',
      align: 'left',
    },
    {
      title: 'Phone',
      dataIndex: 'phone',
      key: 'phone',
      align: 'left',
      render: (text) => <span className='ellipsis-text'>{formatPhone(text)}</span>,
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      align: 'left',
    },
    {
      title: 'Address',
      dataIndex: 'address',
      key: 'address',
      align: 'left',
      render: (text) => <span className='ellipsis-text'>{text}</span>,
    },
    {
      title: 'Website',
      dataIndex: 'website',
      key: 'website',
      align: 'left',
    },
    {
      title: 'Products',
      dataIndex: 'totalProducts',
      key: 'totalProducts',
      align: 'left',
    },
    {
      title: 'Quantity',
      dataIndex: 'quantity',
      key: 'quantity',
      align: 'left',
    },
    {
      title: 'Sold',
      dataIndex: 'totalSold',
      key: 'totalSold',
      align: 'left',
    },
    {
      title: 'Inventory',
      dataIndex: 'inventory',
      key: 'inventory',
      align: 'left',
    },
    {
      title: 'Total',
      dataIndex: 'totalPrice',
      key: 'totalPrice',
      align: 'left',
      render: (text) => <span>{formatCurrency(text)}</span>,
    },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      align: 'left',
      render: (id: string, record: IResSupplier) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <Button block height={2} ntype='LIGHT_PRIMARY' onClick={() => handleDeleteSupplier(record)}>
            Delete
          </Button>
          <Button block height={2} ntype='DEFAULT' onClick={() => handleEditSupplier(record)}>
            Edit
          </Button>
          <Button block height={2} ntype='DARK_BLUE' onClick={() => handleDetailSupplier(record)}>
            Detail
          </Button>
        </div>
      ),
    },
  ];

  const handleChangePage = (page: number) => {
    dispatch(
      settingServiceActions.setSuppliersSettingParams({
        page: page,
      })
    );
  };
  return (
    <Container>
      <NewTable
        columns={columns}
        dataSource={suppliers}
        loading={loading}
        rowKey={'id'}
        pagination={{
          total: totalElement ?? 0,
          pageSize: params.size,
          current: params.page,
          onChange: handleChangePage,
          hideOnSinglePage: true,
        }}
      />
      <AddOrUpdateSupplierModal ref={addOrUpdateSupplierRef} />
      <ModalConfirm ref={confirmModalRef} />
    </Container>
  );
};

export default SuppliersSettingTable;

const Container = styled.div``;
